import { render, staticRenderFns } from "./IconMore.vue?vue&type=template&id=32d41633&scoped=true"
import script from "./IconMore.vue?vue&type=script&lang=js"
export * from "./IconMore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d41633",
  null
  
)

export default component.exports